import React, { useEffect, useRef, useState } from "react";
import {
    Box,
    Breadcrumbs,
    Button,
    Paper,
    TextField,
    Typography
} from "@mui/material";
import { Link } from "react-router-dom";
import { DataGridPro, GridColDef } from "@mui/x-data-grid-pro";
import { ThreeDot } from "react-loading-indicators";
import emptyImage from "../assets/images/image.png";
import Grid from "@mui/material/Grid2";
import Dialog, { DialogProps } from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { showToast } from "../Components/Toast";
import {
    addDepartment,
    addRole,
    getRbacMetaDetails,
    updateDepartmentStatus,
    updateRoleStatus
} from "./ServiceRbac";

export const RolesDep = () => {
    const [rows, setRows] = useState([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [allRows, setAllRows] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [roles, setRoles] = useState([]);

    const [isDeptDialogOpen, setIsDeptDialogOpen] = useState(false);
    const [isRoleDialogOpen, setIsRoleDialogOpen] = useState(false);
    const [newDeptName, setNewDeptName] = useState("");
    const [newRoleName, setNewRoleName] = useState("");

    const [fullWidth] = React.useState(true);
    const [maxWidth] = React.useState<DialogProps["maxWidth"]>("xs");

    const [isConfirmDialogOpen, setIsConfirmDialogOpen] =
        useState<boolean>(false);
    const [selectedDept, setSelectedDept] = useState<any>(null);

    const [isConfirmDialogOpenR, setIsConfirmDialogOpenR] =
        useState<boolean>(false);
    const [selectedRole, setSelectedRole] = useState<any>(null);

    const [paginationModel, setPaginationModel] = React.useState({
        page: 0,
        pageSize: 10 // Default page size
    });
    const fetchData = async () => {
        const data = await getRbacMetaDetails();

        if (data?.status && data?.data?.length) {
            const meta = data?.data[0];
            console.log("asdfsdfasf", meta);

            setDepartments(
                meta.Department?.map((item: any, index: number) => ({
                    id: index + 1,
                    Department: item?.deptName,
                    deptID: item?.deptID,
                    status: item?.status
                })) || []
            );

            setRoles(
                meta.Role_in_the_Company?.map((item: any, index: number) => ({
                    id: index + 1,
                    Role_in_the_Company: item?.roleName,
                    roleID: item?.roleID,
                    status: item?.status
                })) || []
            );
        }
    };
    useEffect(() => {
        fetchData();
    }, []);

    const handleAddDepartment = async () => {
        if (newDeptName.trim() === "") return;

        const result = await addDepartment(newDeptName);
        if (result?.status) {
            setDepartments([
                ...departments,
                { id: departments.length + 1, Department: newDeptName }
            ]);
            showToast({
                type: "success",
                message: "Department added successfully"
            });
        } else {
            showToast({ type: "error", message: "Failed to add department" });
        }
        setNewDeptName("");
        setIsDeptDialogOpen(false);
    };

    const handleAddRole = async () => {
        if (newRoleName.trim() === "") return;

        const result = await addRole(newRoleName);
        if (result?.status) {
            setRoles([
                ...roles,
                { id: roles.length + 1, Role_in_the_Company: newRoleName }
            ]);
            showToast({ type: "success", message: "Role added successfully" });
        } else {
            showToast({ type: "error", message: "Failed to add role" });
        }
        setNewRoleName("");
        setIsRoleDialogOpen(false);
    };

    const handleUpdateDepartmentStatus = async (dept: any) => {
        const newStatus = dept.status === "Active" ? "Inactive" : "Active";

        const result = await updateDepartmentStatus(dept.deptID, newStatus);

        if (result?.status) {
            await fetchData();
            showToast({
                type: "success",
                message: "Status updated successfully"
            });
        } else {
            showToast({ type: "error", message: "Failed to update status" });
        }
    };

    const handleUpdateRoleStatus = async (role: any) => {
        const newStatus = role.status === "Active" ? "Inactive" : "Active";

        const result = await updateRoleStatus(role.roleID, newStatus);

        if (result?.status) {
            // setDepartments((prev) =>
            //   prev.map((d) => (d.id === role.id ? { ...d, status: newStatus } : d))
            // );
            await fetchData();
            showToast({
                type: "success",
                message: "Status updated successfully"
            });
        } else {
            showToast({ type: "error", message: "Failed to update status" });
        }
    };

    const departmentColumns: GridColDef[] = [
        { field: "id", headerName: "ID", width: 90, disableColumnMenu: true },
        {
            field: "Department",
            headerName: "Department",
            width: 350,
            disableColumnMenu: true
        },
        {
            field: "action",
            headerName: "Action",
            width: 200,
            disableColumnMenu: true,
            renderCell: (params) => {
                return (
                    <Button
                        variant="outlined"
                        size="small"
                        color={
                            params.row.status === "Inactive"
                                ? "error"
                                : "success"
                        }
                        onClick={() => {
                            setSelectedDept(params.row);
                            setIsConfirmDialogOpen(true);
                        }}
                    >
                        {params.row.status === "Active" ? "Active" : "Inactive"}
                    </Button>
                );
            }
        }
    ];

    const roleColumns: GridColDef[] = [
        { field: "id", headerName: "ID", width: 90, disableColumnMenu: true },
        {
            field: "Role_in_the_Company",
            headerName: "Role",
            width: 350,
            disableColumnMenu: true
        },
        {
            field: "action",
            headerName: "Action",
            width: 200,
            disableColumnMenu: true,
            renderCell: (params) => {
                return (
                    <Button
                        variant="outlined"
                        size="small"
                        color={
                            params.row.status === "Inactive"
                                ? "error"
                                : "success"
                        }
                        onClick={() => {
                            setSelectedRole(params.row);
                            setIsConfirmDialogOpenR(true);
                        }}
                    >
                        {params.row.status === "Active" ? "Active" : "Inactive"}
                    </Button>
                );
            }
        }
    ];

    return (
        <>
            <Breadcrumbs aria-label="breadcrumb" sx={{ marginBottom: "10px" }}>
                <Typography sx={{ fontSize: "14px" }}>
                    <Link
                        to="/layout/Dashboard"
                        style={{
                            color: "#0070BA",
                            fontSize: "14px",
                            textDecoration: "none"
                        }}
                    >
                        Home
                    </Link>
                </Typography>
                {[
                    <>
                        <Typography key="final" sx={{ fontSize: "14px" }}>
                            Roles and Departments
                        </Typography>
                    </>
                ]}
            </Breadcrumbs>
            <Typography variant="h5" mb={1}>
                Roles and Departments
            </Typography>
            <Box
                sx={{
                    borderRadius: "5px",
                    marginTop: "16px",
                    background: "#fff",
                    padding: "15px"
                }}
            >
                <Grid container spacing={2} mb={2}>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => setIsDeptDialogOpen(true)}
                        >
                            Add Department
                        </Button>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Button
                            sx={{ float: "right" }}
                            variant="outlined"
                            color="primary"
                            onClick={() => setIsRoleDialogOpen(true)}
                        >
                            Add Role
                        </Button>
                    </Grid>
                </Grid>
                <Paper
                    sx={{
                        // height: 400,
                        height:
                            rows?.length > 4
                                ? "62vh"
                                : rows?.length > 0
                                  ? "auto"
                                  : "62vh",
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        boxShadow: "none"
                    }}
                >
                    {!isLoading ? (
                        departments.length > 0 || roles.length > 0 ? (
                            <>
                                <DataGridPro
                                    rows={departments}
                                    columns={departmentColumns}
                                    getRowId={(row) => row?.id}
                                    pagination={departments.length > 10}
                                    paginationModel={paginationModel}
                                    onPaginationModelChange={setPaginationModel}
                                    pageSizeOptions={[10, 20]}
                                    disableRowSelectionOnClick={true}
                                    sx={{ marginRight: "10px" }}
                                />
                                <DataGridPro
                                    rows={roles}
                                    columns={roleColumns}
                                    getRowId={(row) => row?.id}
                                    pagination={roles.length > 10}
                                    paginationModel={paginationModel}
                                    onPaginationModelChange={setPaginationModel}
                                    pageSizeOptions={[10, 20]}
                                    disableRowSelectionOnClick={true}
                                    sx={{ marginLeft: "10px" }}
                                />
                            </>
                        ) : (
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    gap: "8px",
                                    padding: "20px"
                                }}
                            >
                                <>
                                    <img
                                        src={emptyImage}
                                        alt="Empty"
                                        width="300px"
                                    />
                                    <b style={{ color: "#0009" }}>
                                        No Roles and Department Available
                                    </b>
                                </>
                            </div>
                        )
                    ) : (
                        <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            height="50vh"
                        >
                            <ThreeDot
                                color="#1976d2"
                                size="medium"
                                text=""
                                textColor=""
                            />
                        </Box>
                    )}
                </Paper>
            </Box>
            {/* --------------Add Deparatment--------------- */}
            <Dialog
                maxWidth={maxWidth}
                fullWidth={fullWidth}
                open={isDeptDialogOpen}
                onClose={() => setIsDeptDialogOpen(false)}
            >
                <DialogTitle>Add Department</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Department Name"
                        type="text"
                        fullWidth
                        variant="outlined"
                        value={newDeptName}
                        onChange={(e) => setNewDeptName(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => setIsDeptDialogOpen(false)}
                        color="error"
                    >
                        Cancel
                    </Button>
                    <Button onClick={handleAddDepartment}>
                        Add Department
                    </Button>
                </DialogActions>
            </Dialog>
            {/* -------------Add Role-------------- */}
            <Dialog
                maxWidth={maxWidth}
                fullWidth={fullWidth}
                open={isRoleDialogOpen}
                onClose={() => setIsRoleDialogOpen(false)}
            >
                <DialogTitle>Add Role</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Role Name"
                        type="text"
                        fullWidth
                        variant="outlined"
                        value={newRoleName}
                        onChange={(e) => setNewRoleName(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => setIsRoleDialogOpen(false)}
                        color="error"
                    >
                        Cancel
                    </Button>
                    <Button onClick={handleAddRole}>Add Role</Button>
                </DialogActions>
            </Dialog>
            {/* -------------Active Inactive Department-------------- */}

            <Dialog
                open={isConfirmDialogOpen}
                onClose={() => setIsConfirmDialogOpen(false)}
            >
                <DialogTitle>Confirm Status Change</DialogTitle>
                <DialogContent>
                    <Typography>
                        Are you sure you want to mark this department as{" "}
                        {selectedDept?.status === "Active"
                            ? "Inactive"
                            : "Active"}
                        ?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => setIsConfirmDialogOpen(false)}
                        color="error"
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={async () => {
                            if (selectedDept) {
                                await handleUpdateDepartmentStatus(
                                    selectedDept
                                );
                            }
                            setIsConfirmDialogOpen(false);
                        }}
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>

            {/* -------------Active Inactive Role-------------- */}

            <Dialog
                open={isConfirmDialogOpenR}
                onClose={() => setIsConfirmDialogOpenR(false)}
            >
                <DialogTitle>Confirm Status Change</DialogTitle>
                <DialogContent>
                    <Typography>
                        Are you sure you want to mark this department as{" "}
                        {selectedRole?.status === "Active"
                            ? "Inactive"
                            : "Active"}
                        ?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => setIsConfirmDialogOpenR(false)}
                        color="error"
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={async () => {
                            if (selectedRole) {
                                await handleUpdateRoleStatus(selectedRole);
                            }
                            setIsConfirmDialogOpenR(false);
                        }}
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};
